export default "__VITE_ASSET__9_4CrJQ4__"